import { Action } from '@ngrx/store';

export const LOCK_ACCOUNT_SUCCESS = '[Customer] User Lock Account Success';

export class LockAccountSuccessAction implements Action {
  readonly type = LOCK_ACCOUNT_SUCCESS;

  constructor(public payload: { user: { key: string, identifier: string, reason?: string }, status: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/LockAccountSuccessAction.ts